const getCabinGroupsDictionary = (rates) => {
  const obj = {};
  if (rates) {
    [...new Set(rates.map((r) => r.cabinCategoryLocation))]
      .forEach((location) => {
        const filteredRates = rates.filter((r) => r.cabinCategoryLocation === location);
        filteredRates.sort((a, b) => a.lowestRate - b.lowestRate);
        obj[location] = filteredRates;
      });
  }
  return obj;
};

export default getCabinGroupsDictionary;
